export const scrollToContent = e => {
  const content = document.querySelector('#content')

  if (content && 'scrollIntoView' in content) {
    e.preventDefault()
    // content.scrollIntoView({ behavior: 'smooth' })
    const top = content.getBoundingClientRect().top + pageYOffset
    scroll({ top, behavior: 'smooth' })
  }
}

export const createHtmlText = text => {
  return {__html: text};
}


// WEBPACK FOOTER //
// ./src/helpers.js